module.exports = __webpack_public_path__ + "img/gallery07.4153c8e9.jpg";